export default __webpack_public_path__ + "static/media/gallery_00.0e2fa669.jpg";